export const PIDCategories = [
  {
    heading: "headingOne",
    dataTarget: "#collapseOne",
    ariaControls: "collapseOne",
    title: "Pumps/Fans/Blower/Compressors",
  },
  {
    heading: "headingTwo",
    dataTarget: "#collapseTwo",
    ariaControls: "collapseTwo",
    title: "Motors/Drives",
  },
  {
    heading: "headingThree",
    dataTarget: "#collapseThree",
    ariaControls: "collapseThree",
    title: "Heat Exchangers",
  },
  {
    heading: "headingFour",
    dataTarget: "#collapseFour",
    ariaControls: "collapseFour",
    title: "Conveyors",
  },
  {
    heading: "headingFive",
    dataTarget: "#collapseFive",
    ariaControls: "collapseFive",
    title: "Mixers",
  },
  {
    heading: "headingSix",
    dataTarget: "#collapseSix",
    ariaControls: "collapseSix",
    title: "Screens",
  },
  {
    heading: "headingSeven",
    dataTarget: "#collapseSeven",
    ariaControls: "collapseSeven",
    title: "Aerators",
  },
  {
    heading: "headingEight",
    dataTarget: "#collapseEight",
    ariaControls: "collapseEight",
    title: "Burners",
  },
  {
    heading: "headingNine",
    dataTarget: "#collapseNine",
    ariaControls: "collapseNine",
    title: "Pipelines",
  },
  {
    heading: "headingTen",
    dataTarget: "#collapseTen",
    ariaControls: "collapseTen",
    title: "Signal Lines",
  },
  {
    heading: "headingEleven",
    dataTarget: "#collapseEleven",
    ariaControls: "collapseEleven",
    title: "Valves",
  },
  {
    heading: "headingTwelve",
    dataTarget: "#collapseTwelve",
    ariaControls: "collapseTwelve",
    title: "Valve Operators",
  },
  {
    heading: "headingThirteen",
    dataTarget: "#collapseThirteen",
    ariaControls: "collapseThirteen",
    title: "Pipeline Symbols",
  },
  {
    heading: "headingFourteen",
    dataTarget: "#collapseFourteen",
    ariaControls: "collapseFourteen",
    title: "Inline Equipment",
  },
  {
    heading: "headingFifteen",
    dataTarget: "#collapseFifteen",
    ariaControls: "collapseFifteen",
    title: "Instruments",
  },
  {
    heading: "headingSixteen",
    dataTarget: "#collapseSixteen",
    ariaControls: "collapseSixteen",
    title: "Tanks/Vessels",
  },
  {
    heading: "headingSeventeen",
    dataTarget: "#collapseSeventeen",
    ariaControls: "collapseSeventeen",
    title: "Grit Handling",
  },
  {
    heading: "headingEighteen",
    dataTarget: "#collapseEighteen",
    ariaControls: "collapseEighteen",
    title: "Presses",
  },
  {
    heading: "headingNineteen",
    dataTarget: "#collapseNineteen",
    ariaControls: "collapseNineteen",
    title: "Emergency Equipment",
  },
  {
    heading: "headingTwenty",
    dataTarget: "#collapseTwenty",
    ariaControls: "collapseTwenty",
    title: "Sample Equipment",
  },
  {
    heading: "headingTwentyone",
    dataTarget: "#collapseTwentyone",
    ariaControls: "collapseTwentyone",
    title: "Page Connectors & Demarcations",
  },
  {
    heading: "headingTwentytwo",
    dataTarget: "#collapseTwentytwo",
    ariaControls: "collapseTwentytwo",
    title: "Vehicles",
  },
  {
    heading: "headingTwentythree",
    dataTarget: "#collapseTwentythree",
    ariaControls: "collapseTwentythree",
    title: "Packaged Equipment",
  },
  {
    heading: "headingTwentyfour",
    dataTarget: "#collapseTwentyfour",
    ariaControls: "collapseTwentyfour",
    title: "WNI Assemblies",
  },
  {
    heading: "headingTwentyfive",
    dataTarget: "#collapseTwentyfive",
    ariaControls: "collapseTwentyfive",
    title: "WRNI Assemblies",
  },
  {
    heading: "headingTwentysix",
    dataTarget: "#collapseTwentysix",
    ariaControls: "collapseTwentysix",
    title: "P Scheme Green Boxes",
  },
];
